<div class="columns">
  <div class="column custom-box has-background-white p-3">
    <div class="alerts-container" *ngIf="isVoluntaryChangeDisabled">
      <div class="column">
        <app-alert type="warning">
          <span title> {{ 'itinerary-actions.voluntary-change-disabled-title' | translate }} </span>
          <span description>
            {{ voluntaryChangeAllowedMessage }}
          </span>
        </app-alert>
      </div>
    </div>

    <div class="alerts-container" *ngIf="getSelectedPassengersHasInvalidCoupons$ | async">
      <div class="column">
        <app-alert type="warning">
          <span title> {{ 'itinerary-actions.invalid-coupons-title' | translate }} </span>
          <span description>
            {{ 'itinerary-actions.invalid-coupons-description' | translate }}
          </span>
        </app-alert>
      </div>
    </div>

    <div class="alerts-container" *ngIf="pnrIsEncrypted">
      <div class="column">
        <app-alert type="warning">
          <span title> {{ 'itinerary-actions.invalid-coupons-title' | translate }} </span>
          <span description>
            {{ 'itinerary-actions.pnr-is-encrypted' | translate }}
          </span>
        </app-alert>
      </div>
    </div>

    <div class="alerts-container" *ngIf="!!pnrInfo.warnings?.length && isAirline">
  <div class="column">
    <app-alert type="warning" *ngFor="let warning of pnrInfo.warnings">
      <span title>{{ 'shared.warning' | translate }}</span>
      <span description>
        {{
          warning?.includes('|')
            ? warning.split('|')[0]?.trim() + ' ' + ('shared.NoAllowedVol' | translate)
            : warning
        }}
      </span>
    </app-alert>
  </div>
</div>

    <div *ngIf="error || (errorChangesByException && messageError != null)" class="alerts-container">
      <div class="column">
        <div *ngIf="error">
          <app-alert type="warning">
            <span title>{{ 'shared.warning' | translate }}</span>
            <span description> {{ 'exception-mode.error-PastDateNoAllowed' | translate }}</span>
          </app-alert>
        </div>

        <div *ngIf="errorChangesByException && messageError != null" class="v-separator">
          <app-alert type="warning">
            <span title>{{ 'shared.warning' | translate }}</span>
            <span description> {{ messageError | translate }}</span>
          </app-alert>
        </div>
      </div>
    </div>

    <div class="body-container">
      <div class="column">
        <div class="columns">
          <div class="column is-4">
            <app-passengers [passengers]="(pnrInfo$ | async)?.passengers" [mode]="selectedMode$ | async"
              [enabledCheckboxes]="true" [somePassengerHasTicket]="somePassengerHasTicket$ | async"
              [restart]="error$ | async" (selectPassenger)="selectPassengers($event)">
            </app-passengers>
          </div>
          <div class="column">
            <app-segments [selectedMode]="selectedMode$ | async" [segments]="(pnrInfo$ | async)?.itinerary?.segments"
              [endorsement]="(pnrInfo$ | async)?.endorsement" [encryptedFare]="(pnrInfo$ | async)?.encryptedFare"
              [isReIssueFlow]="(pnrInfo$ | async)?.isReIssueFlow" [isTicketOpen]="(pnrInfo$ | async)?.isOpen"
              [baggageAllowance]="(pnrInfo$ | async)?.baggageAllowance" [restart]="error$ | async"
              (sendSelecteds)="selectFlights($event)" (loadAlternatives)="goToInvoluntary()"></app-segments>

            <div>
              <div class="v-separator"></div>

              <div class="hr-separator">
                <hr class="dotted" />
              </div>

              <span class="title is-5">
                {{ 'itinerary-actions.reserve-actions' | translate }}
              </span>

              <div class="reserve-actions-container">
                <div class="reserve-actions-button-container">
                  <button class="button is-link is-outlined" (click)="switchOAGFltModal()">
                    {{ 'itinerary-info.segments-info.oag-flt-status' | translate }}
                  </button>
                </div>

                <div *ngIf="(pnrInfo$ | async)?.voidAllowed && voidTransactionEnabled"
                  class="reserve-actions-button-container">
                  <button class="button is-danger is-link is-outlined" (click)="voidTransactionModal(false)">
                    <span>
                      <em class="mdi mdi-alert-octagram-outline mdi-18px"></em>
                    </span>
                    {{ 'itinerary-info.void-transaction.button' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<log-in-log-modal [isActive]="showLogInLogModal" (closeModal)="switchLogInLogModal()"></log-in-log-modal>

<app-oag-flt-status-modal [isActive]="showOAGFltModal" (closeModal)="switchOAGFltModal()"></app-oag-flt-status-modal>

<app-void-transaction-modal [isActive]="showVoidTransactionModal" (closeModal)="voidTransactionModal($event)">
</app-void-transaction-modal>